import {camelCase} from 'lodash';

const specialities = [
    {spec: 'Allergy and immunology', sub: ['Internal Medicine', 'Pediatrics'], superior: false},
    {spec: 'Adolescent medicine', sub: ['Pediatrics', 'Family Medicine'], superior: false},
    {spec: 'Anesthesiology', sub: ['Family Medicine'], superior: false},
    {spec: 'Aerospace medicine', sub: ['Family Medicine'], superior: false},
    {spec: 'Cardiology', sub: ['Internal Medicine'], superior: false},
    {spec: 'Cardiothoracic surgery', sub: ['General Surgery'], superior: false},
    {spec: 'Child and adolescent psychiatry', sub: ['Psychiatry', 'Pediatric'], superior: false},
    {spec: 'Clinical neurophysiology', sub: ['Neurology'], superior: false},
    {spec: 'Colorectal surgery', sub: ['General Surgery'], superior: false},
    {spec: 'Dermatology', sub: ['None'], superior: true},
    {spec: 'Developmental pediatrics', sub: ['Pediatrics'], superior: false},
    {spec: 'Emergency medicine', sub: ['Family Medicine'], superior: false},
    {spec: 'Endocrinology', sub: ['Internal Medicine'], superior: false},
    {spec: 'Family Medicine', sub: ['None'], superior: true},
    {spec: 'Forensic pathology', sub: ['Pathology'], superior: false},
    {spec: 'Forensic psychiatry', sub: ['Psychiatry'], superior: false},
    {spec: 'Gastroenterology', sub: ['Internal Medicine'], superior: false},
    {spec: 'General Surgery', sub: ['None'], superior: true},
    {spec: 'General surgical oncology', sub: ['General Surgery'], superior: false},
    {spec: 'Geriatrics', sub: ['Family Medicine', 'Internal Medicine'], superior: false},
    {spec: 'Geriatric psychiatry', sub: ['Geriatrics', 'Psychiatry'], superior: false},
    {spec: 'Gynecologic oncology', sub: ['Obstetrics and gynecology'], superior: false},
    {spec: 'Hematology', sub: ['Internal Medicine', 'Pathology'], superior: false},
    {spec: 'Hematologic pathology', sub: ['Hematology', 'Pathology'], superior: false},
    {spec: 'Infectious disease', sub: ['Internal Medicine', 'Pediatrics'], superior: false},
    {spec: 'Internal Medicine', sub: ['None'], superior: true},
    {spec: 'Interventional radiology', sub: ['Radiology'], superior: false},
    {
        spec: 'Intensive care medicine',
        sub: ['Anesthesiology', 'Emergency Medicine', 'Internal Medicine'],
        superior: false,
    },
    {spec: 'Maternal-fetal medicine', sub: ['Obstetrics and gynecology'], superior: false},
    {spec: 'Medical biochemistry', sub: ['Internal Medicine'], superior: false},
    {spec: 'Medical genetics', sub: ['None'], superior: true},
    {spec: 'Medical oncology', sub: ['Internal Medicine'], superior: false},
    {spec: 'NeonatologyPediatrics', sub: ['Neonatal'], superior: false},
    {spec: 'Nephrology', sub: ['Internal Medicine'], superior: false},
    {spec: 'Neurology', sub: ['Internal Medicine'], superior: false},
    {spec: 'Neuropathology', sub: ['Pathology'], superior: false},
    {spec: 'Neurosurgery', sub: ['None'], superior: true},
    {spec: 'Nuclear medicine', sub: ['None'], superior: true},
    {spec: 'Obstetrics and gynecology', sub: ['Family Medicine'], superior: false},
    {spec: 'Occupational medicine', sub: ['Family Medicine', 'Internal Medicine'], superior: false},
    {spec: 'Ophthalmology', sub: ['None'], superior: true},
    {spec: 'Orthopedic surgery', sub: ['None'], superior: true},
    {spec: 'Oral and maxillofacial surgery', sub: ['None'], superior: true},
    {spec: 'Otorhinolaryngology', sub: ['None'], superior: true},
    {spec: 'Palliative care', sub: ['Family Medicine', 'Internal Medicine', 'Pediatrics'], superior: false},
    {spec: 'Pathology', sub: ['None'], superior: true},
    {spec: 'Pediatrics', sub: ['None'], superior: true},
    {spec: 'Pediatric allergy and immunology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric cardiology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric emergency medicine', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric endocrinology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric gastroenterology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric hematology and oncology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric infectious disease', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric nephrology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric respiratory medicine', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric rheumatology', sub: ['Pediatrics'], superior: false},
    {spec: 'Pediatric surgery', sub: ['General Surgery'], superior: false},
    {spec: 'Physical medicine and rehabilitation', sub: ['None'], superior: true},
    {spec: 'Plastic, reconstructive and aesthetic surgery', sub: ['General Surgery'], superior: false},
    {spec: 'Psychiatry', sub: ['None'], superior: true},
    {spec: 'Public health', sub: ['Family Medicine'], superior: false},
    {spec: 'Radiation oncology', sub: ['None'], superior: true},
    {spec: 'Radiology', sub: ['None'], superior: true},
    {spec: 'Reproductive endocrinology and infertility', sub: ['Obstetrics and gynecology'], superior: false},
    {spec: 'Respiratory medicine', sub: ['Internal Medicine'], superior: false},
    {spec: 'Rheumatology', sub: ['Internal Medicine'], superior: false},
    {spec: 'Sports medicine', sub: ['Family Medicine'], superior: false},
    {spec: 'Thoracic surgery', sub: ['General Surgery'], superior: false},
    {spec: 'Neuroradiology', sub: ['Radiology'], superior: false},
    {spec: 'Urology', sub: ['None'], superior: true},
    {spec: 'Vascular surgery', sub: ['General Surgery'], superior: false},
];
export const Specialities = specialities.filter(sp => sp.superior).map(sp => sp.spec);

const subTree = specialities.reduce((memo, sp) => {
    if (sp.superior) return memo;
    const subSpecialities = sp.sub;
    subSpecialities.forEach(subSpec => {
        if (!memo[subSpec]) memo[subSpec] = [];
        memo[subSpec].push(sp.spec);
    });
    return memo;
}, {});
const flatTree = Object.keys(subTree).reduce((memo, key) => ({...memo, [key]: getSelfAndChildren(key)}), {});

export const SubSpecialities = Specialities.reduce((memo, key) => {
    if (flatTree[key]) memo[key] = flatTree[key];
    else memo[key] = [key];
    return memo;
}, {});

function getSelfAndChildren(childStr) {
    const child = subTree[childStr];
    if (!child) return [childStr];
    return [childStr, ...child.map(getSelfAndChildren).flat()];
}
export const TranslateSpecialities = (list, t) =>
    list.map(speciality => t(`medicalSpecialities.${camelCase(speciality)}`));

export const HealthCareFacility = {
    privatePractice: 'Private practice',
    generalHospital: 'General hospital',
    hospital: 'Hospital',
};

export const TranslateHealthCareFacilities = t =>
    Object.keys(HealthCareFacility).reduce(
        (acc, key) => ({
            ...acc,
            [key]: t(`healthCareFacilities.${key}`),
        }),
        {}
    );
